import './Portfolio.css';
import barnyardBg from '../../assets/backgrounds/barnyard-bg.webp';
import nastyBg from '../../assets/backgrounds/nasty-bg.png';
import barnyardLogo from '../../assets/logos/barnyard.png';
import nastyLogo from '../../assets/logos/nasty.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const brands = [
  {
    category: "Food & Beverage",
    name: "The Barnyard",
    tagline: "A Modern Approach to Honest, Healthy Dining",
    description:
      "The Barnyard is our flagship healthy dining concept, built around the belief that food should be both nourishing and genuinely enjoyable. Rooted in high-quality ingredients, thoughtful sourcing, and a nature-inspired environment, the brand delivers a balanced lifestyle experience that resonates with today's conscious consumer. With strong market traction and a loyal customer base, The Barnyard is positioned as a scalable concept designed to grow across key urban destinations.",
    src: barnyardBg,
    logo: barnyardLogo,
    link: "https://thebarnyard.me/",
  },
  {
    category: "Food & Beverage",
    name: "Nasty Cookie",
    tagline: "Reinventing the Modern Indulgence Experience",
    description:
      "Nasty Cookie is a bold, fast-growing dessert brand redefining indulgence through creative product innovation and strong brand identity. Known for its signature cookies, milkshakes, and high-energy retail experience, the brand captures a younger, trend-driven audience while maintaining operational efficiency and scalability. With a distinctive positioning, Nasty Cookie is built to evolve into a leading name in the premium dessert segment.",
    src: nastyBg,
    logo: nastyLogo,
    link: "https://nastycookie.com/",
  },
];

function Portfolio() {
  return (
    <div id="portfolio">
      <div className="portfolio-container">
        <div className="portfolio-header">
          <h1>F&B Portfolio Overview</h1>
          <p className="portfolio-subtitle">Our Brands</p>
          <p className="portfolio-intro">
            We are proud to have a diverse portfolio of F&B brands that we have
            invested in and helped solidify their expansions.
          </p>
        </div>

        <div className="portfolio-brands">
          {brands.map((brand, index) => (
            <div className="portfolio-brand" key={index}>
              <div className="portfolio-brand-image">
                <img src={brand.src} alt={brand.name} />
                <div className="portfolio-brand-overlay"></div>
                <span className="portfolio-brand-category">
                  {brand.category}
                </span>
              </div>
              <div className="portfolio-brand-content">
                <img
                  src={brand.logo}
                  alt={`${brand.name} logo`}
                  className="portfolio-brand-logo"
                />
                <h3>{brand.tagline}</h3>
                <p>{brand.description}</p>
                {brand.link && (
                  <a
                    href={brand.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="portfolio-brand-link"
                  >
                    Learn More{" "}
                    <FontAwesomeIcon icon={faArrowRight} />
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
